import { Component, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { MatChipsModule } from '@angular/material/chips';
import { AutomationReplacementChipsComponent } from '../../../../../common/components';
import { MatOptionModule } from '@angular/material/core';
import { CrmFieldsSelectorService, FieldOverride } from '../../../../../data-services/crm-fields-selector.service';
import { supportedFilterFieldTypes } from '../../../filters';

@Component({
  templateUrl: './crm-field-selector-dialog.component.html',
  styleUrls: ['./crm-field-selector-dialog.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    GalaxyFormFieldModule,
    AutomationReplacementChipsComponent,
    GalaxyButtonLoadingIndicatorModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatOptionModule,
  ],
})
export class CrmFieldSelectorDialogComponent {
  public supportedFieldTypes = supportedFilterFieldTypes;
  formControl = new FormControl([]);
  selectorService = inject(CrmFieldsSelectorService);
  crmObjectType = 'Company';
  label = 'CRM_FIELDS_DIALOG.COMPANY_FIELDS';
  fieldOverrides: FieldOverride[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<CrmFieldSelectorDialogComponent, string[]>,
  ) {
    this.crmObjectType = data.crmObjectType;
    if (this.crmObjectType === 'Contact') {
      this.label = 'CRM_FIELDS_DIALOG.CONTACT_FIELDS';
    }
    if (this.crmObjectType === 'Opportunity') {
      this.label = 'CRM_FIELDS_DIALOG.OPPORTUNITY_FIELDS';
    }

    if (data?.fieldOverrides) {
      this.fieldOverrides = data.fieldOverrides;
    }
  }

  save(): void {
    this.dialogRef.close(this.formControl.value);
  }
}
